import { memo } from 'react';
import { IconProps } from './iconType';

export const ResetIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <path
        d="M1.66651 10.0003C1.66651 14.6028 5.39734 18.3337 9.99984 18.3337C14.6023 18.3337 18.3332 14.6028 18.3332 10.0003C18.3332 5.39783 14.6023 1.66699 9.99984 1.66699V3.33366C11.5675 3.33378 13.085 3.88638 14.2857 4.89435C15.4864 5.90232 16.2935 7.30119 16.5651 8.84518C16.8368 10.3892 16.5556 11.9795 15.771 13.3367C14.9865 14.694 13.7487 15.7313 12.2752 16.2665C10.8016 16.8017 9.18664 16.8004 7.71394 16.263C6.24123 15.7256 5.00502 14.6864 4.22252 13.3279C3.44001 11.9695 3.16127 10.3787 3.43526 8.83518C3.70925 7.29161 4.51844 5.89397 5.72067 4.88782L7.49984 6.66699V1.66699H2.49984L4.53817 3.70616C3.63583 4.48773 2.91231 5.4544 2.4168 6.54047C1.92129 7.62654 1.66539 8.80656 1.66651 10.0003Z"
        fill={color}
      />
    </svg>
  );
});

ResetIcon.displayName = 'ResetIcon';
